import { Link } from "react-router-dom";
import { store } from "../../../../../../stores/Store";
import { useFormik } from "formik";
import { Case, WorkflowStep } from "../../../../../../models/Interfaces";
import Field from "../../../../../form/fields/Field";
import Ajax from "../../../../../../Ajax";
import { Button } from "@mui/material";
import { json } from "stream/consumers";
import { Alert } from "../../../../../..";
import React from "react";

interface WorkflowEvidenceProps {
    caseNode: Case;
    workflowStep: WorkflowStep;
}

// This workflow step is expected to have some data inside childrenObjectsJson in this structure:
//  {
//      [enquiryUid]: ["evidence_1_id", "evidence_1_id"]
//  }
// This object should be used as is to define formik.initialValues.

export default function WorkflowEvidence ({caseNode, workflowStep}: WorkflowEvidenceProps) {

    const [saveScheduled, setSaveScheduled] = React.useState(false)
    const autoSaveTimer = React.useRef<NodeJS.Timeout>()

    // workflowStep.childrenObjectsJson
    const {folderNode} = store.NodeStore
    const enquiries = store.NodeStore.getFolderChildren?.filter(node => node.uid?.includes("ENQUIRY") && node.additionalOutcomeData?.evidence)
    
    var defaultInitialValues = null
    try {
        var additionalContentData = JSON.parse(workflowStep.additionalContentData)
        if (typeof additionalContentData === "object") {
            defaultInitialValues = additionalContentData
        }
    } catch (ex) {
        console.log("Failed to load initial values", ex)
    }

    if (!defaultInitialValues) {
        defaultInitialValues = {}
        enquiries.forEach(enquiry => {
            defaultInitialValues[enquiry.uid] = []
        })
    }

    var formik = useFormik({

        initialValues: defaultInitialValues,

        onSubmit: async (values) => {

            var newStep = {...workflowStep, additionalContentData: JSON.stringify(values)}

            await Ajax.Workflow.StepUpdate(newStep).then(async () => {
                await store.NodeStore.refreshFolderNode()
            }).catch(() => {
                Alert({message: "Failed to update workflow step"})
            })

            formik.resetForm()
            formik.setValues(values)
            setSaveScheduled(false)
        }
    })

    const scheduleSave = () => {
        setSaveScheduled(true)

        if (autoSaveTimer.current) {
            clearTimeout(autoSaveTimer.current)
        }
        autoSaveTimer.current = setTimeout(() => {
            formik.handleSubmit()
            clearTimeout(autoSaveTimer.current)
        }, 2000)
    }

    const EvidenceCheckbox = ({enquiry, evidence}) => {

        var enquiryEvidence = formik.values && enquiry.uid in formik.values && formik.values[enquiry.uid] ? formik.values[enquiry.uid] : []
        var checked = enquiryEvidence?.includes(evidence.value)
        
        return (
            <div style={{marginBottom: "6px"}}>
                <Field.Checkbox 
                    value={checked} 
                    warning={false}
                    label={<small>{evidence.label}</small>}
                    onChange={() => {
                        var evidenceIds = [evidence.value]

                        if (evidence.children?.length) {
                            evidence.children.forEach(evidence => {
                                evidenceIds.push(evidence.value)
                                if (evidence.children?.length) {
                                    evidence.children.forEach(evidence => {
                                        evidenceIds.push(evidence.value)
                                    })
                                }
                            })
                        }
                        
                        var newValue = checked
                            ? enquiryEvidence.filter(evidenceId => !evidenceIds.includes(evidenceId))
                            : [...enquiryEvidence, ...evidenceIds]

                        formik.setFieldValue(enquiry.uid, newValue)
                        scheduleSave()
                    }} />

                {Array.isArray(evidence.children) && evidence.children.length ? (
                    <div style={{paddingLeft: "15px", margin: "3px 0 3px 7px", borderLeft: "1px solid grey"}}>
                        {evidence.children?.map((childEvidence, i) => (
                            <EvidenceCheckbox enquiry={enquiry} evidence={childEvidence} />
                        ))}
                    </div>
                ) : null}
            </div>
        )
    }

    return (
        <div className={formik.isSubmitting ? "disabled" : ""} style={{display: "grid", gap: "5px"}}>

            {enquiries?.map((enquiry, i) => (
                <div key={i}>
                    <small style={{fontWeight: 600}}>
                        Here is a list of all the required evidence stated in <Link className="link" to={`/app/main/${folderNode?.uid}/${enquiry.uid}`}>{enquiry.uid.replace("ENQUIRY_", "Assessment ")}</Link>.
                    </small>

                    <div style={{fontSize: "12px"}}>
                        {enquiry.additionalOutcomeData?.evidence?.map((evidence, i) => <EvidenceCheckbox enquiry={enquiry} evidence={evidence} />)}
                    </div>
                </div>
            ))}

            {saveScheduled ? (
                <small style={{height: "12px"}}>
                    Saving...
                </small>
            ) : null}
        </div>
    )
}